import { useMemo, useEffect, useRef, useState } from 'react'
import { useMutation, useQueryClient } from 'react-query'
import { useLocation } from 'react-router-dom'

import { useTable, Row} from 'react-table'

import { DLMLabellingCustomRow } from './columns/DLMLabellingCustomRow'
import { DLMLabellingColumns as UserColumns } from './columns/_columnsUser'
import { DLMLabellingColumns as ApplicantColumns } from './columns/_columnsApplicant'

import { KTCardBody} from '../../../../../../../_metronic/helpers'

import { filter as filterArray, orderBy, remove, findIndex } from 'lodash'
import { useDLMLabellingListContext } from '../components'
import { DLMSiteApplication } from '../../../_models'

import { PropsWithNotes, TableHead, TablePagination } from '../../../../../../components/table'
import { useAuth } from '../../../../../auth'

import { SubmitInspectionResponseModal as ApplicantResponseModal } from '../../../../../company/doclabel/submit-inspection-response-modal/SubmitInspectionResponseModal'
import { SiteInspectionResponseModal as UserResponseModal } from '../../../../../setsco/doclabel/site-inspection-workflow/SiteInspectionResponseModal'

import { ApplicationTerminateDialog, ApplicationTerminateDialogRef,  useApplicationTerminateRequestDialogState,  useModalNoteDialogState } from '../../../../../../components/dialogs'
import { processDLMApplicationTermination, requestDLMApplicationTermination } from '../../../_requests'
import { getErrorMessage, processNoteValues } from '../../../../../../components/helpers'
import { DLMApplicationReassignModal } from '../../../../../setsco/doclabel/applications/application-view/reassign-modal/DLMApplicationReassignModal'
import { useSiteLabellingState } from './columns/_store'

const DLMLabellingTable = () => {
  const queryClient = useQueryClient();
  const location = useLocation();

  const { data, setData } = useSiteLabellingState(state => state);
  const [appID, setAppID] = useState(0);

  const { initModal, toggleShow } = useModalNoteDialogState(state => state);
  const { initModal : initTerminate, toggleShow: toggleTerminate } = useApplicationTerminateRequestDialogState(state => state);


  const lastpath = useMemo(() => {
    if (! (location && location.pathname)) return '';
    return location.pathname.split('/').pop();
  }, [location]);

  const { sites, state, updateState, currentSite, setCurrentSite, itemIDForDelete, setItemIDForDelete, itemIDForUpdate, setItemIDForUpdate, objectOption1, setObjectOption1, workflow } = useDLMLabellingListContext();
  const { page, items_per_page, nrecs } = state;

  const { currentUser, hasRole } = useAuth();

  const modalRef = useRef<ApplicationTerminateDialogRef | null>(null);

  const [show_reassign, showReassign] = useState(false);

  const show_data = useMemo(() => {
    return data.slice(((page - 1) * items_per_page), page * items_per_page);
  }, [data, page, items_per_page]);

  const columns = useMemo(() => {
    return (currentUser && currentUser.isSetsco) ? UserColumns : ApplicantColumns;
  } , [currentUser]);

  const {getTableProps, getTableBodyProps, headerGroups, rows, prepareRow} = useTable({    
    columns,
    data: show_data
  })

  // APPLICANT TERMINATION

  const terminateLabelling = useMutation((payload) => requestDLMApplicationTermination(payload),
  {
    onError: (error) => {
      alert(getErrorMessage(error))
    },
    onSuccess: () => {
      queryClient.invalidateQueries(['DLMAPPLICATIONS-LIST', { lastpath }]);
      queryClient.invalidateQueries(['DLMAPPLICATIONS-LIST', { listmode: 'own'} ]);
      queryClient.invalidateQueries(['DLMAPPLICATION-LOAD', { dlmappid: appID } ]);
    },
    onSettled: () => {
      setItemIDForDelete(undefined);
    }
  })

  const onConfirmTerminateLabelling = async (values: any) => {

    const payload = {
      ...values,
      siteApplicationid: itemIDForDelete
    }

    await terminateLabelling.mutateAsync(payload)
  }


  const cancelTerminateLabelling = useMutation((payload) => requestDLMApplicationTermination(payload),
  {
    onError: (error) => {
      alert(getErrorMessage(error))
    },
    onSuccess: () => {
      queryClient.invalidateQueries(['DLMAPPLICATIONS-LIST', { lastpath}]);
      queryClient.invalidateQueries(['DLMAPPLICATIONS-LIST', { listmode: 'own'} ]);
      queryClient.invalidateQueries(['DLMAPPLICATION-LOAD', { dlmappid: appID } ]);
    },
    onSettled: () => {
    setItemIDForDelete(undefined);
    setItemIDForUpdate(undefined);
    }
  })


  const onConfirmCancelTerminate = async (values: any) => {
    const payload = {
      ...values,
      siteApplicationid: itemIDForDelete,
      cancelRequest: true
    }

    await cancelTerminateLabelling.mutateAsync(payload)
  }

  const onConfirmReplyTerminate = async (values: any) => {
    const payload = {
      ...values,
      siteApplicationid: itemIDForUpdate,
      cancelRequest: false
    }

    await cancelTerminateLabelling.mutateAsync(payload)
  }

  // USER TERMINATION
  const processTerminateLabelling = useMutation((payload: any) => processDLMApplicationTermination(payload),
  {
    onError: (error) => {
      alert(getErrorMessage(error))
    },
    onSuccess: () => {
      queryClient.invalidateQueries(['DLMAPPLICATIONS-LIST', { lastpath }]);
      queryClient.invalidateQueries(['DLMAPPLICATIONS-LIST', { listmode: 'own'} ]);
      queryClient.invalidateQueries(['DLMAPPLICATION-LOAD', { dlmappid: appID } ]);
    },
    onSettled: () => {
    setItemIDForDelete(undefined);
    }
  })

  const processTerminationLabellingRequest = async (values: any) => {

    const payload = {
      siteApplicationid: itemIDForDelete,
      approved: (values?.verdict && values.verdict === 'approved') ? true : false,
      reply: (values?.verdict && values.verdict === 'request') ? true : false,
    }

    processNoteValues(values, payload);

    if (payload.approved && values?.waive) {
      Object.assign(payload, {waive: true});
    }

    await processTerminateLabelling.mutateAsync(payload);
  }

  const closeModal = () => {
    setCurrentSite(null);
  }

  useEffect(()=> {
    const d_cnt = data && data.length ? data.length : 0;
    if (nrecs !== d_cnt) {
      updateState({nrecs : d_cnt});
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data, nrecs]);

  useEffect(() => {
    if (itemIDForDelete === undefined || (! (sites && sites.length > 0)) ) {
      if (modalRef.current) modalRef.current.hide();
      toggleShow(false);
      return;
    }

    // User process
    if (currentUser && currentUser?.isSetsco) {
      // show Application Terminate modal
      if (modalRef.current) modalRef.current.show();
      return;
    }

    // Applicant Process
    // @ts-ignore
    const _idx = findIndex(sites, { id : itemIDForDelete })
    if (_idx === -1) return;

    const _site = sites[_idx];
    if (
      (_site?.requestTerminateState !== undefined) &&
      (_site.requestTerminateState === 'REQUEST_TERMINATE_APPLICATION' || _site.requestTerminateState === 'REQUEST_TERMINATE_APPLICATION_REPLY')
    ) {
      initModal({
        title: 'Cancel Labelling Termination Request',
        message: "Are you sure you want to cancel the labelling termination request?",
        onOK: onConfirmCancelTerminate,
        onCancel: () => { setItemIDForDelete(undefined); setItemIDForUpdate(undefined); },
        hasNote: 'required',
        hasAttachment: 'yes',
        submitText: "YES",
        cancelText: 'NO',
      });

      toggleShow(true);
    } else {
      initTerminate({
        title: 'TERMINATE SITE LABELLING',
        message: `Are you sure you want to terminate labelling for this site : ${_site.projectName} (${_site.projectLocation})?`,
        onOK: onConfirmTerminateLabelling,
      });

      toggleTerminate(true);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sites, itemIDForDelete, currentUser]);

  useEffect(() => {
      if (itemIDForUpdate === undefined) {
        toggleShow(false);
        return;
      }
      initModal({
        title: 'Labelling Termination Information Request',
        message:  "Send additional information for labelling termination request.",
        onOK :onConfirmReplyTerminate,
        onCancel: () => { setItemIDForDelete(undefined); setItemIDForUpdate(undefined); },
        hasNote: 'required',
        hasAttachment: 'yes',
        submitText: "Submit",
        cancelText: 'Cancel',
      });
      toggleShow(true);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [itemIDForUpdate]);

  useEffect(() => {
    showReassign(objectOption1 ? true : false)
  }, [objectOption1])


  useEffect(() => {

    if (! (sites && sites.length > 0)) return;

    const appID = (sites[0]?.dlmApplication && sites[0].dlmApplication?.id) ? sites[0].dlmApplication.id : 0;
    let _rows = filterArray(sites, (o : any) => (! o?.deleted)).map(o => ({...o, showNotes: true}));

    if (currentUser && currentUser?.isSetsco && (! hasRole(['System Admin','DLM Admin']))) {
      remove(_rows, (o: DLMSiteApplication) => (!(o?.assignedTo && o.assignedTo?.id && o.assignedTo.id === currentUser.id)));
    }

    const _donerows = remove(_rows, (o: any) => {
      return (o.state === 'Completed' || o.state === 'COMPLETED')
    });

    setData([...orderBy(_rows, ['projectName'], ['asc']), ...orderBy(_donerows, ['state','dteUpd', 'projectName'], ['asc','desc','asc'])]);
    setAppID(appID);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sites, currentUser])

  return (
  <>
  <KTCardBody className='py-4'>
    <div className='table-responsive'>
      <table
        id='kt_table_dlm_labelling'
        className='table align-middle table-row-bordered table-row-gray-300 fs-7 gy-2 dataTable no-footer'
        {...getTableProps()}
      >
        <TableHead {...{headerGroups}} />
        <tbody className='text-gray-800 fs-7' {...getTableBodyProps()}>
          {(rows && rows.length > 0) &&
          rows.map((row: Row<PropsWithNotes<DLMSiteApplication>>, i) => {
            prepareRow(row)
            return <DLMLabellingCustomRow key={row.id} row={row}  />
          })
          }
        </tbody>
      </table>
    </div>
    <TablePagination isLoading={false} state={state} updateState={updateState} />
  </KTCardBody>
  { currentSite && (
  (currentUser && currentUser?.isSetsco) ? (
  <UserResponseModal site={currentSite} workflow={workflow} doClose={closeModal}/>
  ) : (
  <ApplicantResponseModal site={currentSite} doClose={closeModal}/>
  )
  )}

  { (currentUser && currentUser?.isSetsco) &&
  <ApplicationTerminateDialog
    ref={modalRef}
    title="Process Labelling Termination Request"
    message=""
    onOK={processTerminationLabellingRequest}
    onCancel={() => setItemIDForDelete(undefined)}
  />
  }

  { (show_reassign && setObjectOption1 && objectOption1) &&
  <DLMApplicationReassignModal
    appID={appID}
    appState="label"
    workflow={workflow}
    assignedId={objectOption1.assignedId}
    role={objectOption1.assignRole}
    doClose={() => {
      showReassign(false);
      setObjectOption1(null);
    }}
    siteApplicationid={objectOption1.siteApplicationid}
  />
  }

  </>
)
}

export {DLMLabellingTable}
